// extracted by mini-css-extract-plugin
export default {"body":"Error404Page_body__TXyLL"};